import {
  crmApiUrl,
  crmApiV3Url,
  apiUrl,
  apiV2Url,
  apiV3Url,
  internalV2ApiUrl,
  staticUrl,
  straightApiUrl,
  analyticsUrl,
} from '../config/baseUrl';

const cleanUrl = url => url.replace(/([^:]\/)\/+/g, '$1');

export default {
  crmApi: path => cleanUrl(`${crmApiUrl}/${path}`),
  crmApiV3: path => cleanUrl(`${crmApiV3Url}/${path}`),
  baseApi: path => cleanUrl(`${straightApiUrl}/${path}`),
  api: path => cleanUrl(`${apiUrl}/${path}`),
  apiV2: path => cleanUrl(`${apiV2Url}/${path}`),
  apiV3: path => cleanUrl(`${apiV3Url}/${path}`),
  internalV2Api: path => cleanUrl(`${internalV2ApiUrl}/${path}`),
  static: path => cleanUrl(`${staticUrl}/${path}`),
  section: ({ root, entityId, sectionName }) =>
    `${root}/${entityId}/${sectionName}`,
  analyticsUrl: path => cleanUrl(`${analyticsUrl}/${path}`),
};
